import GetBalanceResponse from '../model/get-balance-response'

export default function createPlaceholderBalanceResponse(): GetBalanceResponse {
  return {
    data: {
      balanceByUserId: {
        transactions: {
          edges: [],
          pageInfo: {
            endCursor: null,
            startCursor: null,
            hasNextPage: false,
            hasPreviousPage: false,
          },
        },
        amount: {
          value: '0',
          currency: 'RUB',
        },
      },
    },
  }
}
